// removed by extract-text-webpack-plugin
module.exports = {"tagCloud":"antd-pro-tagCloud"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/TagCloud/index.less
// module id = 365
// module chunks = 0 1